import { IColumn } from '@repo/ui';
import { useLegends } from 'presentation/app/hooks/useLegends';

export const makeStudentsWithoutRegisteringAppColumns = (): IColumn[] => {
  const { getLegends } = useLegends();
  return [
    {
      title: getLegends('ESTUDANTE', false),
      dataKey: 'student',
      width: 300,
      cellRenderer: ({ rowData }) => (
        <div className="d-flex flex-column">
          <span>
            <strong>{rowData?.student}</strong>
          </span>
          <span style={{ fontWeight: 'lighter' }}>{rowData?.cpf}</span>
        </div>
      ),
    },
    {
      title: 'Criado em',
      dataKey: 'createdAt',
    },
  ];
};
